import { imageUrl } from '@helpers/image';
import * as React from 'react';
import S from './SocialLinks.styles';
const SocialLinks = ({ items, label }) => {
    return (React.createElement(S.Container, { "aria-label": label },
        React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, target: "_blank" },
                React.createElement(S.Icon, { alt: item.title, loading: "lazy", src: imageUrl({ src: item.icon }, { width: 37, height: 37, rmode: 'pad' }), width: "37", height: "37" }))))))));
};
export default SocialLinks;
